export default __webpack_public_path__ + "static/media/sidebar.3d152c2b.png";